import { Injectable } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { RestUserService } from 'src/app/service/rest/user/rest-user.service';
import { UpsUser } from './user.model';

@Injectable()
export class UserRepositoryService {

  private _backofficeUsers: UpsUser[] = [];
  public dataSourceUsers = new MatTableDataSource<UpsUser>();

  usersLoaded : boolean = false;

  constructor(private userRest : RestUserService) {  }

  loadBackofficeUsers() : Observable<UpsUser[]> {
    return this.userRest.getUsers();
  }

  get backofficeUsers(): UpsUser[] {
    return this._backofficeUsers;
  }

  set backofficeUsers(users : UpsUser[]) {
    this._backofficeUsers = users;
    this.dataSourceUsers = new MatTableDataSource<UpsUser>(users);
  }
}
